import React from "react"

function IconMagnifyingGlassMinus({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="magnifying-glass-minus"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-magnifying-glass-minus"
      {...props}
    >
      <path
        d="M10.147 2.393a7.207 7.207 0 0 1 5.337 12.053l5.473 5.87a.655.655 0 0 1-.87.971l-.088-.078-5.48-5.877a7.208 7.208 0 1 1-4.373-12.938zm0 1.31a5.899 5.899 0 1 0-.002 11.797 5.899 5.899 0 0 0 .002-11.797zm3.342 5.244a.655.655 0 0 1 .106 1.3l-.106.009H6.873a.655.655 0 0 1-.106-1.3l.106-.01h6.616z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconMagnifyingGlassMinus
